import { motion } from "framer-motion";
import Reveal from "./Reveal";
import { SERVICES } from "@/data/content";

const ServiceRow = ({ service, index }) => (
  <Reveal delay={index * 0.08}>
    <div
      className="group relative border-b border-white/10 py-10 lg:py-14 grid grid-cols-1 lg:grid-cols-12 gap-6 items-start transition-colors duration-500 hover:bg-white/[0.02] px-2 sm:px-4 -mx-2 sm:-mx-4"
      data-testid={`service-row-${service.index}`}
    >
      <span className="lg:col-span-2 font-mono-accent text-white/20 text-3xl lg:text-4xl group-hover:text-[#00D2D3]/50 transition-colors duration-500">
        {service.index}
      </span>
      <div className="lg:col-span-6">
        <h3 className="font-outfit font-bold text-2xl sm:text-3xl lg:text-4xl text-white tracking-tight leading-tight group-hover:translate-x-2 transition-transform duration-500">
          {service.title}
        </h3>
      </div>
      <div className="lg:col-span-4">
        <p className="text-white/55 font-manrope leading-relaxed text-sm sm:text-base">
          {service.description}
        </p>
      </div>
    </div>
  </Reveal>
);

const Services = () => {
  return (
    <section
      id="servicos"
      className="relative py-24 lg:py-32 max-w-7xl mx-auto px-6 lg:px-10"
      data-testid="services-section"
    >
      <Reveal>
        <p className="font-mono-accent text-xs text-[#00D2D3] tracking-[0.25em] uppercase mb-4">
          O que fazemos
        </p>
        <h2 className="font-outfit font-bold text-3xl sm:text-4xl text-white max-w-2xl tracking-tight">
          Três frentes. Um objetivo:{" "}
          <span className="text-white/50">resultado real.</span>
        </h2>
      </Reveal>

      <div className="mt-10">
        {SERVICES.map((service, i) => (
          <ServiceRow service={service} index={i} key={service.index} />
        ))}
      </div>
    </section>
  );
};

export default Services;
